<template>
    <sa-page-layout :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading" :btnNewVisible="true" :btnRefreshVisible="true" @refresh="onRefresh" :titolo="titolo">
        <template slot="table-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Record Totali: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="xl" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="item">
                        {{ item.index + 1 }}
                    </template>
                    <template v-slot:cell(codiceTariffa)="{ item }">
                        <router-link class="sa-edit-link" :to="'/tariffe/view/' + item.id"> {{ item.codiceTariffa }} </router-link>
                    </template>
                </b-table>
            </div>
        </template>
        <template slot="table-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Record Totali: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </template>
    </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
export default {
    components: { SaPageLayout },
    mounted() {
        let me = this;
        me.loadData();
    },
    data() {
        return {
            pathResource: "/leonidaaccettazionetariffe",
            linkedit: "/tariffe",
            currentPage: 1,
            perPage: 50,
            rows: 0,
            titolo: "Lista Tariffe",
            showModalLoading: false,
            filtro: {},
            items: [],
            fields: [
                {
                    label: "",
                    key: "index",
                    thStyle: "width: 3rem",
                },
                {
                    label: "Codice Tariffa",
                    key: "codiceTariffa",
                    sortable: true,
                    thStyle: "width: 6rem",
                },
                {
                    label: "Descrizione Tariffa",
                    key: "descrizioneTariffa",
                    sortable: true,
                },
                {
                    label: "Importo",
                    key: "importo",
                    sortable: true,
                    thStyle: "width: 6rem",
                },
                {
                    label: "Iva",
                    key: "iva",
                    sortable: true,
                    thStyle: "width: 8rem",
                },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtro.forPage = me.perPage;
            me.filtro.page = me.currentPage;
            me.showModalLoading = true;
            axios
                .get(link, { params: me.filtro })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onReset() {},
    },
};
</script>
